import { Input, Tooltip } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
import Button from "@/common/atoms/Button";

const { TextArea } = Input;
const SearchInputWithButton = ({
  search,
  setSearch,
  onSearch,
  placeholder,
  btnText,
  readOnly = false,
  isBackground = false,
  inputType = "input",
  isLoading = false,
  className,
  parentClassName
}) => {
  const inputCommonProps = {
    readOnly: readOnly || isLoading,
    placeholder,
    value: search,
    onChange: (e) => setSearch(e.target.value),
    className: `border-none focus:ring-0 px-5 py-3 text-gray-700 text-lg flex-1 bg-transparent focus:bg-transparent hover:bg-transparent placeholder:text-[#5B738B] placeholder:text-[12px] ${className}`
  };

  return (
    <div
      className={`${
        isBackground ? "bg-white h-[75px] border border-[#D9D9D9]" : ""
      } ai-input flex w-full mt-6 h-[55px] rounded-[16px] overflow-hidden ${parentClassName}`}>
      {inputType === "textArea" ? (
        readOnly ? (
          <Tooltip title={placeholder}>
            <TextArea autoSize {...inputCommonProps} />
          </Tooltip>
        ) : (
          <TextArea autoSize {...inputCommonProps} />
        )
      ) : readOnly ? (
        <Tooltip title={placeholder}>
          <Input {...inputCommonProps} />
        </Tooltip>
      ) : (
        <Input {...inputCommonProps} />
      )}
      <Button
        loading={isLoading}
        type="primary"
        className={`${
          isBackground
            ? "h-[58px] min-w-[10rem] max-w-full leading-[52px]"
            : "!px-8"
        } hidden sm:block my-auto mx-2 !pt-1 rounded-lg`}
        onClick={onSearch}>
        {btnText}
      </Button>
      <Button
        type="primary"
        icon={<ArrowUpOutlined />}
        className={`${
          isBackground ? "h-[56px] !w-20" : ""
        } block sm:hidden !px-0 my-auto mx-2 pt-2 rounded-md !w-14`}
        onClick={onSearch}
      />
    </div>
  );
};

export default SearchInputWithButton;
